export function infrastructureAvailable() {
    const $sliderHolder = $(".infrastructure-available");
    const $sliderThumbnails = $sliderHolder.find(".infrastructure-maps-nav");
    const $sliderContent = $sliderHolder.find(".infrastructure-maps-holder");
    const $sliderThumbnailsLength = $sliderThumbnails.find(".item").length;
    const $sliderTab = $sliderThumbnails.find(".item");
    const $window = $(window);
    let timeOutId;
    let timeOutIdHover;
    $sliderContent.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        infinite: false,
        asNavFor: $sliderThumbnails,
        autoplay: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 3000
    });
    $sliderThumbnails.slick({
        slidesToShow: 1.1,
        slidesToScroll: 1,
        asNavFor: $sliderContent,
        arrows: false,
        dots: false,
        focusOnSelect: true,
        mobileFirst: true,
        infinite: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2.2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $sliderContent.on("afterChange", function (event, slick, currentSlide) {
        if (currentSlide === $sliderThumbnailsLength - 1) {
            timeOutId = setTimeout(function () {
                $sliderContent.slick("slickGoTo", 0);
                $sliderContent.slick('refresh');
                $sliderThumbnails.slick("slickGoTo", 0);
                $sliderThumbnails.slick('refresh');
            }, 2999);
        }
    });
    $sliderContent.on("beforeChange", function (event, slick, currentSlide) {
        if (currentSlide === $sliderThumbnailsLength - 1) {
            $sliderThumbnails.find(".item").removeClass("paused");
            clearTimeout(timeOutId);
        }
    });
    $window.on("resize", function () {
        let $slidesShown = $sliderThumbnails.slick("slickGetOption", "slidesToShow");
        if ($sliderThumbnailsLength <= $slidesShown) {
            setTimeout(() => {
                $sliderThumbnails.find(".slick-track").css("transform", "translate3d(0px, 0px, 0px)");
            }, 500);
        }
    });
    if ($window.width() < 1200) {
        $sliderContent.on("touchstart", function (e) {
            $sliderContent.slick("slickPause");
            $sliderThumbnails.find(".slick-current .item").addClass("paused");
            $(this).one("touchend", function (e) {
                $(this).off("touchmove");
                $sliderContent.slick("slickPlay");
                $sliderThumbnails.find(".item").removeClass("paused");
            });
        });
    }

    function pauseSlider() {
        $sliderContent.slick("slickPause");
        $sliderThumbnails.find(".slick-current .item").addClass("paused");
        clearTimeout(timeOutId);
        clearTimeout(timeOutIdHover);
    }

    function resumeSlider() {
        $sliderContent.slick("slickPlay");
        $sliderThumbnails.find(".slick-current .item").removeClass("paused");
        timeOutIdHover = setTimeout(function () {
            if ($sliderThumbnails.find(".slick-current").index() === $sliderThumbnailsLength - 1) {
                $sliderContent.slick("slickGoTo", 0);
                $sliderContent.slick('refresh');
                $sliderThumbnails.slick("slickGoTo", 0);
                $sliderThumbnails.slick('refresh');
            }
        }, 2999);
    }

    if ($window.width() > 1199) {
        $sliderThumbnails.hover(function () {
            pauseSlider();
        }, function () {
            resumeSlider();
        });
    }

    $window.on("load scroll", function () {
        let $winTop = $window.scrollTop();
        let $windowBottomPosition = ($winTop + $window.height());
        $sliderThumbnails.each(function () {
            let $this = $(this);
            let $sectionTop = $this.offset().top;
            if ($windowBottomPosition > $sectionTop) {
                $this.addClass("show");
                $sliderContent.slick("slickPlay");
                $this.find($sliderTab).removeClass("paused");
            } else {
                $this.removeClass("show");
                $sliderContent.slick("slickPause");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/infrastructureAvailable.js